// src/pages/NotFound.tsx
import { Link } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center px-4">
        <h1 className="text-6xl md:text-8xl font-bold text-autoBlue mb-4">404</h1>
        <p className="text-2xl text-gray-700 mb-8">Opla! Stran ni bila najdena.</p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button 
            onClick={() => window.history.back()} 
            className="bg-gray-200 text-gray-800 font-medium py-3 px-6 rounded-md hover:bg-gray-300 transition-all duration-300 inline-flex items-center justify-center"
          >
            <ArrowLeft className="mr-2" size={20} />
            Nazaj
          </button>
          <Link 
            to="/" 
            className="bg-autoBlue text-white font-medium py-3 px-6 rounded-md hover:bg-blue-700 transition-all duration-300 inline-flex items-center justify-center"
          >
            <Home className="mr-2" size={20} />
            Domov
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;